import LocalStorage from "../LocalStorage";
import {isDefined} from "../../../utils/Utils";
import moment = require("moment");

/**
 * Routing map filters
 */
export class RoutingMapFilters {
	constructor(public dateFrom: moment.Moment,
		public dateTo: moment.Moment,
		public undisplayedSalesEngineersIds: string[],
		public directionFromId: string,
		public directionToId: string,
		public routeIndex: number) {}

	static default(): RoutingMapFilters {
		return new RoutingMapFilters(moment(), moment(), [], null, null, null);
	}

	/**
	 * Parse local storage data.
	 * @param data data to parse.
	 * @returns {RoutingMapFilters}
	 */
	static getFromLocalStorageData(data: any): RoutingMapFilters {
		if (!isDefined(data)) {
			return RoutingMapFilters.default();
		}
		return new RoutingMapFilters(data.dateFrom, data.dateTo, data.undisplayedSalesEngineersIds, data.directionFromId,
			data.directionToId, data.routeIndex);
	}

	updateDateFrom(value: moment.Moment): RoutingMapFilters {
		this.dateFrom = value;
		LocalStorage.saveRoutingMapFilters(this);
		return this;
	}

	updateDateTo(value: moment.Moment): RoutingMapFilters {
		this.dateTo = value;
		LocalStorage.saveRoutingMapFilters(this);
		return this;
	}

	updateUndisplayedSalesEngineers(value: string[]): RoutingMapFilters {
		this.undisplayedSalesEngineersIds = value;
		LocalStorage.saveRoutingMapFilters(this);
		return this;
	}

	updateDirectionFrom(value: string): RoutingMapFilters {
		this.directionFromId = value;
		this.routeIndex = null;
		LocalStorage.saveRoutingMapFilters(this);
		return this;
	}

	updateDirectionTo(value: string): RoutingMapFilters {
		this.directionToId = value;
		this.routeIndex = null;
		LocalStorage.saveRoutingMapFilters(this);
		return this;
	}

	updateRouteIndex(value: number): RoutingMapFilters {
		this.routeIndex = value;
		LocalStorage.saveRoutingMapFilters(this);
		return this;
	}
}
